import React from "react";
import CommunityAddPage from "../community/components/CommunityAddPage";
import { ASK_FOR_HELP } from "../community/constants";
import { useRequireSectionVisible } from "../../client/hooks/useRequireSectionVisible";

export default function AddAskForHelpPage() {
  useRequireSectionVisible("showAskForHelp");
  return <CommunityAddPage section={ASK_FOR_HELP} />;
}
